// removed by extract-text-webpack-plugin
module.exports = {"desktop":"1366px"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/foundations/Grids/LeftSection.css
// module id = 796
// module chunks = 0